/**
 * Opens the Nostium reservation widget by programmatically clicking
 * the widget's floating button.
 */
export const openNostiumWidget = () => {
  // The Nostium widget renders a direct <button> child of <body>
  const widgetButton = document.querySelector<HTMLElement>('body > button');
  
  if (widgetButton) {
    widgetButton.click();
    return;
  }

  // Fallback: open URL directly
  window.open(
    'https://portal.nostium.com/reservering/47rku4oldyfk/alpaca-dordrecht',
    '_blank',
    'noopener,noreferrer'
  );
};
